import axios from 'axios'
import { Message  } from 'element-ui'
import config from '@/config2.js'
import store from '@/store/index.js'
// import { getToken } from '@/utils/auth'

// import Vue from "vue";

// 请求拦截（配置发送请求的信息）

// 创建axios实例
// axios.defaults.adapter = require('axios/lib/adapters/xhr');
console.log("加载")
// axios.defaults.adapter = require('axios/lib/adapters/http');
// axios.defaults.baseURL = config.baseURL;
// var varhttpAdapter = require('axios/lib/adapters/http');
const service = axios.create({
    adapter: require('axios/lib/adapters/http'),
    baseURL: config.baseURL, // api的base_url
    timeout: 15000, // 请求超时时间
})



service.interceptors.request.use(function(config) {  // 处理请求之前的配置     
    console.log("axios.interceptors.request")
    console.log(store.state)
    if (store.state.user) {
        // console.log("存在用户")
        console.log(store.state.user.id)
        config.headers.userid = store.state.user.id
    }
    if (store.state.openid) {
        // console.log("存在用户")
        config.headers.openid = store.state.openid
    }

    console.log("config.headers")
    console.log(config.headers)
    return config; 
}, function(error) {  // 请求失败的处理
     
    console.log(error)
    return Promise.reject(error); 
});


// // request拦截器
// service.interceptors.request.use(config => {
//   if (store.getters.token) {
//     config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
//   }
//   return config
// }, error => {
//   // Do something with request error
//   console.log(error) // for debug
//   Promise.reject(error)
// })

// respone拦截器
service.interceptors.response.use(
    response => {
        console.log(response)
            /**
             * code为非20000是抛错 可结合自己业务进行修改
             */
        const res = response.data
        if (res.code != 2000) {
            console.log(res.clientMsg)
                // this.$message({
                //     message: '恭喜你，这是一条成功消息',
                //     type: 'success'
                // });
            Message({
                    message: res.clientMsg,
                    type: 'error',
                    duration: 3 * 1000
                })
                // // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
                // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                //     MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                //         confirmButtonText: '重新登录',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     }).then(() => {
                //         store.dispatch('FedLogOut').then(() => {
                //             location.reload() // 为了重新实例化vue-router对象 避免bug
                //         })
                //     })
                // }
            return Promise.reject('error')
        } else {
            return response.data.data
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service